import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface VerificationRequest {
  email: string;
  phone: string;
  phoneCountryCode: string;
  comments: string;
}

export default (makeCall: MakeCall) =>
  (userId: number, data: VerificationRequest) =>
    makeCall<undefined>('POST', `/api/v2/user/${userId}/verify-manually`, {
      data,
    });
